import React, { useEffect, useState, useRef } from 'react';
import styles from './AdViseStep4.module.css';
import api from '../../../api';
import axios from 'axios'
import { josa, openInstagramMedia } from '../../../util';

const AdViseStep4 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {
    const [isLoading, setIsLoading] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedEvidence, setSelectedEvidence] = useState([]);

    const ScrollContainerRef = useRef(null);

    const stageTexts = [
        "네이버 장소 정보 추출 중...",
        "방문자 리뷰 수집 중...",
        "블로그 게시글 탐색 중...",
        "블로그 게시글 정보 추출 중...",
        "장소 및 리뷰 분석 중..."
    ];

    const whenHomeButtonClicked = () => {
        const back = window.confirm("선택한 정보들이 모두 초기화돼요.\n\n정말 첫 화면으로 돌아갈까요?");
        if(back)
            setAdViseStep(0)
    };

    const getCachedHotpleData = (hotpleId) =>
    axios.get('https://hotple.today/win-api/api/analysis-naver', {
        params: { hotple_id: hotpleId, need_detail: true }
    });

    function getReviewTypeRatios() {
        const reviews = stepProps[4].reviewAnalysis.analysis;
        const total = reviews.length;
        
        if (total === 0) {
            return {
            positive: 0,
            neutral: 0,
            negative: 0,
            average: 0
            };
        }
        
        const counts = {
            positive: 0,
            neutral: 0,
            negative: 0
        };
        
        let totalRating = 0;
        
        reviews.forEach(review => {
            const rating = review.rating;
            totalRating += rating;
        
            if (rating >= 4) {
            counts.positive++;
            } else if (rating === 3) {
            counts.neutral++;
            } else if (rating >= 1 && rating <= 2) {
            counts.negative++;
            }
        });
        
        return {
            positive: Math.round((counts.positive / total) * 100),
            neutral: Math.round((counts.neutral / total) * 100),
            negative: Math.round((counts.negative / total) * 100),
            average: Math.floor((totalRating / total) * 100) / 100  // 소수점 첫째 자리까지
        };
    }
      

    function setStage(stage){
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[4] = {...newProps[4], stage: stage};
            return newProps;
        });
    }

    function whenNextButtonClicked(){
        if(stepProps[4].stage!=5)
            return;

        setAdViseStep(5);
    }

    function getHotpleBadge(hotple) {
        const { start_date, end_date, mention_count, created_at, has_comment_event, uploaded_at } = hotple;
        
        if (has_comment_event && uploaded_at && (new Date(uploaded_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000))) {
            return <div className={styles.periodBadge}>이벤트</div>;
        } 
        if (start_date && new Date(start_date) > new Date()) {
            return <div className={styles.endBadge}>시작예정</div>;
        } 
        if (end_date && new Date(end_date) < new Date()) {
            return <div className={styles.endBadge}>종료됨</div>;
        } 
        if (end_date && new Date(end_date) < new Date(Date.now() + 3 * 24 * 60 * 60 * 1000)) {
            return <div className={styles.periodBadge}>종료임박</div>;
        } 
        if (mention_count > stepProps[3].hotThreshold) {
            return <div className={styles.hotBadge}>HOT</div>;
        } 
        if (created_at && new Date(created_at) >= new Date(Date.now() - 7 * 24 * 60 * 60 * 1000)) {
            return <div className={styles.newBadge}>NEW</div>;
        }
        
        return null; // 아무 배지도 해당 안 되면 null 반환
    }

    function whenNaverMapButtonClicked(place_id) {
        const naverMapWebUrl = `https://m.place.naver.com/place/${place_id}/home`;
        window.open(naverMapWebUrl, '_blank');
    }

    function whenMediaButtonClicked(media_url) {
        openInstagramMedia(media_url);
    }

    function sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    const getBlogReview = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get('https://hotple.today/win-api/api/blog-review', {
                params: { place_id: stepProps[3].hotple.naver_map_place_id }
            });
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[4] = {...newProps[4], blogReviews: response.data.blogReview};
                return newProps;
            });
            setIsLoading(false);
        } catch (error) {
          console.error('Error getBlogReview:', error);
        } finally {
            setStage(3);
        }
    };

    const getAllBlogPostDetail = async () => {
        try {
            setIsLoading(true);
            if (stepProps[4].blogReviews.length > 0) {
                const reviews = stepProps[4].blogReviews.slice(0, 10); // 최대 10개만
                const allTexts = [];
                const allImageUrls = [];
    
                for (let i = 0; i < reviews.length; i++) {
                    if(reviews[i].url.includes('blog.naver')){
                        const result = await getBlogPostDetail(reviews[i].url);

                        const { text, imageUrls } = result;
                        if (text || (imageUrls && imageUrls.length > 0)) {
                            allTexts.push(text);
                            allImageUrls.push(imageUrls);
                        }
        
                        // 마지막 호출이 아니라면 딜레이
                        if (i < reviews.length - 1) {
                            const delay = 100 + Math.random() * 200; // 100~300ms 랜덤
                            await sleep(delay);
                        }
                    }
                    else{
                        allTexts.push(null);
                        allImageUrls.push([]);
                    }
                }
    
                // 모든 데이터 모은 후 한 번에 상태 업데이트
                setStepProps(prev => {
                    const newProps = [...prev];
                    newProps[4] = {
                        ...newProps[4],
                        blogImageUrls: allImageUrls,
                        blogTexts: allTexts
                    };
                    return newProps;
                });
            }
            setIsLoading(false);
        } catch (error) {
            console.error('Error getAllBlogPostDetail:', error);
        } finally {
            setStage(4);
        }
    };

    const analysisPlace = async () => {
        try {
            setIsLoading(true);
            const response = await axios.post('https://hotple.today/win-api/api/analysis-place', {
                place: stepProps[4].place,
                instagramText: stepProps[3].hotple.media_caption,
                blogTexts: stepProps[4].blogTexts,
                visitorReviews: stepProps[4].visitorReviews,
                category: stepProps[3].category !== '전체' ? stepProps[3].category : null,
                need_category_inference: true
            });
            setIsLoading(false);

            return response.data.result;
        } catch (error) {
          console.error('Error analysisPlace:', error);
        }
    }

    const analysisReview = async () => {
        try {
            setIsLoading(true);
            const response = await axios.post(
                'https://hotple.today/win-api/api/analysis-review',
                {
                    place: stepProps[4].place,
                    visitorReviews: stepProps[4].visitorReviews
                }
            );
            setIsLoading(false);

            return response.data.result;
        } catch (error) {
          console.error('Error analysisReview:', error);
        }
    }

    const runAnalysisProcess = async () => {
        try {
            // 두 함수를 동시에 실행
            const [placeAnalysis, reviewAnalysis] = await Promise.all([
                analysisPlace(),
                analysisReview()
            ]);

            setStepProps(prev => {
                const next = [...prev];
                next[4] = {
                    ...next[4],
                    placeAnalysis,
                    reviewAnalysis
                };
                return next;
            });

            const { data } = await api.post(`/advise/admin/advise-hotple`, {
                naver_map_place_id: stepProps[3].hotple.naver_map_place_id,
                place:             stepProps[4].place,
                visitor_reviews:   stepProps[4].visitorReviews,
                blog_reviews:      stepProps[4].blogReviews,
                blog_texts:        stepProps[4].blogTexts,
                blog_image_urls:   stepProps[4].blogImageUrls,
                place_analysis:    placeAnalysis,
                review_analysis:   reviewAnalysis
            });

            const newHotple = data.hotple;
            let region = stepProps[1];

            if(stepProps[1]!=newHotple.region){
                const needRegionChange = window.confirm(`선택된 계정(${stepProps[1]})과 장소 지역(${newHotple.region})이 일치하지 않습니다!\n\n선택 계정을 '${newHotple.region}'${josa(newHotple.region,'로으로')} 변경하여 계속할까요?`);
                if(needRegionChange)
                    region = newHotple.region;
            }
            
            setStepProps(prev => {
                const next = [...prev];
                next[1] = region;
                next[3] = {
                    ...next[3],
                    hotples: [ newHotple, ...next[3].hotples ],
                    hotple: newHotple
                };
                return next;
            });
        } catch (error) {
            console.error('Error in runReviewAnalysisProcess:', error);
        } finally {
            setStage(5);
        }
    };

    const getVisitorReview = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get('https://hotple.today/win-api/api/visitor-review', {
                params: { place_id: stepProps[3].hotple.naver_map_place_id }
            });
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[4] = {...newProps[4], visitorReviews: response.data.visitorReview};
                return newProps;
            });
            setIsLoading(false);
        } catch (error) {
          console.error('Error getVisitorReview:', error);
        } finally {
            setStage(2);
        }
    }

    const getBlogPostDetail = async (url) => {
        try {
            const response = await axios.get(`https://hotple.today/win-api/api/blog-post-detail`, {
                params: { url: url }
            });

            return {
                text: response.data.text,
                imageUrls: response.data.can_reply ? (response.data.imageUrls || []) : []
            };
        } catch (error) {
            return {
                text: null,
                imageUrls: []
            }
        }
    };

    const getNaverPlace = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get('https://hotple.today/win-api/api/naver-place', {
                params: { place_id: stepProps[3].hotple.naver_map_place_id }
            });
            if(response.data.place){
                setStepProps(prev => {
                    const newProps = [...prev];
                    newProps[3] = {
                        ...newProps[3],
                        hotple: {
                            naver_map_place_id: stepProps[3].hotple.naver_map_place_id,
                            name: response.data.place.PlaceDetailBase[0].name,
                            address: response.data.place.PlaceDetailBase[0].roadAddress || response.data.place.PlaceDetailBase[0].address
                        }
                    };
                    newProps[4] = {
                        ...newProps[4],
                        place: response.data.place
                    };
                    return newProps;
                });
            }
            else
                alert('네이버 장소 정보 불러오기 오류');
                setIsLoading(false);
        } catch (error) {
          console.error('Error getNaverPlace:', error);
        } finally{
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[4] = {
                    ...newProps[4],
                    placeId:stepProps[3].hotple.naver_map_place_id,
                    blogReviews:[],
                    blogImageUrls:[],
                    blogTexts:[],
                    visitorReviews:[],
                    reviewAnalysis: null,
                    placeAnalysis: null
                };
                return newProps;
            });
            setStage(1);
        }
    }

    function processStage(stage){
        switch (stage) {
            case 0:
                getNaverPlace();
                break;
            case 1:
                getVisitorReview();
                break;
            case 2:
                getBlogReview();
                break;
            case 3:
                getAllBlogPostDetail();
                break;
            case 4:
                runAnalysisProcess();
                break;
            default:
                break;
        }
    }

    async function tryToGetCache(){
        const hotpleId = stepProps[3].hotple.id || stepProps[3].hotple.hotple_id;

        if(!hotpleId)
            return false;

        const res = await getCachedHotpleData(hotpleId)

        if(res){
            const cached = res.data.hotpleData;
            if (cached) {
                // 캐시가 있으면 바로 세팅 → 5단계 완료 상태
                setStepProps(prev => {
                    const p = [...prev];
                    p[4] = {
                        ...p[4],
                        place:          cached.place,
                        placeId:stepProps[3].hotple.naver_map_place_id,
                        visitorReviews: cached.visitorReviews,
                        blogReviews:    cached.blogReviews,
                        blogTexts:      cached.blogTexts,
                        blogImageUrls:  cached.blogImageUrls,
                        placeAnalysis:  cached.placeAnalysis,
                        reviewAnalysis: cached.reviewAnalysis,
                        stage: 5,
                    };
                    return p;
                });
                return true;
            }
            else
                return false;
        }
        else
            return false;
    }

    async function decideAction(){
        if(stepProps[3].hotple.naver_map_place_id != stepProps[4].placeId){
            const hasCache = await tryToGetCache();
            
            if(!hasCache){
                if(stepProps[4].stage==0)
                    getNaverPlace();
                else
                    setStage(0);
            }
        }
        else
            processStage(stepProps[4].stage);

        if (stepProps[4].stage === 4) {
            setTimeout(() => {
                if (ScrollContainerRef.current) {
                    ScrollContainerRef.current.scrollTo({
                        top: ScrollContainerRef.current.scrollHeight,
                        behavior: 'smooth'
                    });
                }
            }, 100); // 100~200ms 사이 적절
        }
    }

    useEffect(()=>{
        decideAction();
    }, [stepProps[4].stage]);

    return (
        <div className={styles.outerframe}>
            <div className={styles.upperframe}>
                <img className={styles.backbuttonIcon} alt="" src="images/back_android.svg" onClick={()=>setAdViseStep(3)}/>
                <div className={styles.titleframe}>
                    <b className={styles.nextbuttontext}>STEP 4</b>
                    <div className={styles.stepdesc}>핫플의 분석 결과는 어떤가요?</div>
                </div>
                <img className={styles.homebuttonIcon} alt="" src="images/home_outlined.svg" onClick={()=>whenHomeButtonClicked()}/>
            </div>
            <div className={styles.lowerframe} style={{height:`calc(100dvh - ${marginTop}px - 103px - 74px)`}} ref={ScrollContainerRef}>
                <div className={styles.contentframe}>
                    {(stepProps[3].hotple.id || stepProps[3].hotple.hotple_id) &&
                        <div className={styles.hotpleItemFrame}>
                            {stepProps[3].hotple.contents_url && stepProps[3].hotple.contents_url.length>0 ?
                                <div className={styles.imageframe}>
                                    {stepProps[3].hotple.contents_url[0] ?
                                        stepProps[3].hotple.contents_url[0].includes("mp4") ?
                                            <div className={styles.image1frame} style={{marginLeft: '12px'}}>
                                                <video
                                                    className={styles.image1Icon}
                                                    src={stepProps[3].hotple.contents_url[0]}
                                                    poster={stepProps[3].hotple.preview_url || "images/no_instagram_image.svg"}
                                                    controls
                                                    playsInline
                                                />
                                            </div>
                                        :
                                            stepProps[3].hotple.contents_url.map((url, index) => (
                                                <div key={index} className={index == 0 ? styles.image1frame : styles.image2frame} style={{marginLeft: index === 0 ? '12px' : 0}}>
                                                    <img className={index == 0 ? styles.image1Icon : styles.image3Icon} alt="" src={url} />
                                                </div>
                                            ))
                                    :
                                        <div className={styles.image2frame}/>
                                    }
                
                                    <div className={styles.image2frame} onClick={()=>whenMediaButtonClicked(stepProps[3].hotple.media_url)} style={{paddingRight: '12px'}}>
                                        <img className={styles.image2Icon} alt="" src={stepProps[3].hotple.preview_url || "images/no_instagram_image.svg"} />
                                        {stepProps[3].hotple.media_url &&
                                        <>
                                            <div className={styles.infoframe2}>
                                                {
                                                    stepProps[3].hotple.media_id[0].startsWith('H') ?
                                                        <img className={styles.iconfire2} alt="" src="images/fire.svg" />
                                                    :
                                                        <img className={styles.iconinstagramColor} alt="" src="images/instagram.svg" />
                                                }
                                                <div className={styles.username}>@{stepProps[3].hotple.media_creator}</div>
                                            </div>
                                            <div className={styles.infos}>
                                                <img className={styles.iconshare} alt="" src="images/share.svg" />
                                                <div className={styles.div}>
                                                    <span className={styles.txt}>
                                                            <p className={styles.p}>게시글</p>
                                                            <p className={styles.p}>보러가기</p>
                                                    </span>
                                                </div>
                                            </div>
                                        </>
                                        }
                                    </div>
                                </div>
                                :
                                <div/>
                            }

                            <div className={styles.analysisParentFrame}>
                                <div className={styles.analysisScrollFrame}>
                                    {stepProps[3].hotple.key_features && stepProps[3].hotple.key_features.length>0 && 
                                        <div className={styles.analysisFrame}>
                                            <div className={styles.padding1}/>
                                            <div className={styles.positive_text1}>
                                                ★{Math.floor(stepProps[3].hotple.average_rating * 100) / 100}점
                                            </div>
                                            {stepProps[3].hotple.key_features.map(item => (
                                                <div className={styles.positive_text0}>
                                                    {item}
                                                </div>
                                            ))}
                                            <div className={styles.padding1}/>
                                        </div>
                                    }
                
                                    {stepProps[3].hotple.positive_summary && stepProps[3].hotple.positive_summary.length>0 && 
                                        <div className={styles.analysisFrame}>
                                            <div className={styles.padding1}/>
                                            <div className={styles.positive_text}>
                                                긍정 {Math.floor(stepProps[3].hotple.positive_ratio*100)}%
                                            </div>
                                            {stepProps[3].hotple.positive_summary.map(item => (
                                                <div className={styles.positive_text0}>
                                                    "{item}"
                                                </div>
                                            ))}
                                            <div className={styles.padding1}/>
                                        </div>
                                    }
                                </div>
                            </div>

                            <div className={styles.detailframe}>
                                <div className={styles.detailleft}>
                                    <div className={styles.title}>
                                            <div className={styles.hotplename}>{stepProps[3].hotple.name}</div>
                                            {getHotpleBadge(stepProps[3].hotple) && <span className={styles.badgeWrapper}>{getHotpleBadge(stepProps[3].hotple)}</span>}
                                            <div className={styles.ratingframe}>
                                                <img className={styles.iconfire} alt="" src="images/fire.svg" />
                                                <div className={styles.ratingtext}>{stepProps[3].hotple.mention_count}명의 PICK!</div>
                                            </div>
                                    </div>
                                    <div className={styles.tags}>
                                            <div className={styles.tagplaceDetail}>
                                                <div className={styles.orange}>{stepProps[3].hotple.main_category}</div>
                                            </div>
                                            <div className={styles.tagplaceDetail1}>
                                                <div className={styles.orange}>{stepProps[3].hotple.sub_category1} ▸ {stepProps[3].hotple.sub_category2}</div>
                                            </div>
                                            {stepProps[3].hotple.tags && stepProps[3].hotple.tags.slice(0, 3).map((tag, index) => (
                                                <div className={styles.tagplaceDetail2} key={index}>
                                                    <div className={styles.orange}>#{tag}</div>
                                                </div>
                                            ))}
                                    </div>
                                    <div className={styles.caption}>{stepProps[3].hotple.caption}</div>
                                    {stepProps[3].hotple.has_period &&
                                        <div className={styles.commentframe}>
                                                <div className={styles.label}>기간</div>
                                                <div className={styles.period}>{stepProps[3].hotple.start_date && stepProps[3].hotple.start_date.replaceAll('-','/')} ~ {stepProps[3].hotple.end_date && stepProps[3].hotple.end_date.replaceAll('-','/')}</div>
                                        </div>
                                    }
                                </div>
                                {(stepProps[3].hotple.naver_map_place_id || stepProps[3].hotple.media_url) &&
                                    <div className={styles.detailrightbutton}>
                                        {stepProps[3].hotple.media_url &&
                                            <img className={stepProps[3].hotple.media_url.includes('instagram.com') ? styles.iconlikeOutlined : styles.iconlikeOutlined2} alt="" src= {stepProps[3].hotple.media_url.includes('instagram.com') ? "images/instagram_color.svg" : "images/internet.svg"} onClick={()=>whenMediaButtonClicked(stepProps[3].hotple.media_url)}/>
                                        }
                                        {stepProps[3].hotple.naver_map_place_id &&
                                            <img className={styles.iconlikeOutlined} alt="" src= "images/naver.svg" onClick={()=>whenNaverMapButtonClicked(stepProps[3].hotple.naver_map_place_id)}/>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    }
                    
                    {stepProps[4].stage<5 &&
                        <div className={styles.loadingTextframe}>
                            <div className={styles.loadingText}>{stepProps[4].stage+1} / 5</div>
                            <div className={styles.loadingText}>{stageTexts[stepProps[4].stage]}</div>
                        </div>
                    }

                    <div className={styles.refParentFrame}>
                        {stepProps[4].stage>=0 &&
                            <div className={styles.refFrame}>
                                {(stepProps[4].stage==0 && isLoading) ?
                                    <div className={styles.refloader}/> 
                                :
                                    stepProps[4].place ?
                                        <img className={styles.iconChecked} alt="" src= "images/checked_filled.svg"/>
                                    :
                                    <img className={styles.iconFailed} alt="" src= "images/close_filled.svg"/>
                                }
                                <div className={styles.refText}>네이버 장소 정보</div>
                            </div>
                        }
                        {stepProps[4].stage>=1 &&
                            <div className={styles.refFrame}>
                                {(stepProps[4].stage==1 && isLoading) ?
                                    <div className={styles.refloader}/> 
                                :
                                    stepProps[4].visitorReviews.length>0 ?
                                        <img className={styles.iconChecked} alt="" src= "images/checked_filled.svg"/>
                                    :
                                    <img className={styles.iconFailed} alt="" src= "images/close_filled.svg"/>
                                }
                                <div className={styles.refText}>방문자 리뷰 - {stepProps[4].visitorReviews.length}개</div>
                            </div>
                        }
                        {stepProps[4].stage>=2 &&
                            <div className={styles.refFrame}>
                                {(stepProps[4].stage<4 && isLoading) ?
                                    <div className={styles.refloader}/> 
                                :
                                    stepProps[4].blogTexts.length>0 ?
                                        <img className={styles.iconChecked} alt="" src= "images/checked_filled.svg"/>
                                    :
                                    <img className={styles.iconFailed} alt="" src= "images/close_filled.svg"/>
                                }
                                <div className={styles.refText}>인터넷 블로그 - {stepProps[4].blogTexts.length}개</div>
                            </div>
                        }
                        {stepProps[4].stage>=4 &&
                            <div className={styles.refFrame}>
                                {(stepProps[4].stage<4 && isLoading) ?
                                    <div className={styles.refloader}/> 
                                :
                                    stepProps[3].hotple ?
                                        <img className={styles.iconChecked} alt="" src= "images/checked_filled.svg"/>
                                    :
                                    <img className={styles.iconFailed} alt="" src= "images/close_filled.svg"/>
                                }
                                <div className={styles.refText}>인스타그램 - {stepProps[3].hotple?"1":"0"}개</div>
                            </div>
                        }
                    </div>

                    {stepProps[4].stage == 5 &&
                        <div className={styles.promotionalText}>"{stepProps[4].placeAnalysis.promotional_text}"</div>
                    }
                    
                    {stepProps[4].stage == 5 &&
                        <div className={styles.placeframe}>
                            <div className={styles.featuretitle}>이 장소의 매력 포인트!</div>
                            <div className={styles.featureFrame}>
                                {stepProps[4].placeAnalysis && stepProps[4].placeAnalysis.key_features.map((item, index) => (
                                    <div key={index} className={styles.featureText}>{item}</div>
                                ))}
                            </div>
                        </div>
                    }

                    {stepProps[4].stage > 3 &&
                        <div className={styles.placeframe}>
                                <div className={styles.placetitle}>장소 분석 결과</div>
                                <div className={styles.placeresultframe}>
                                    {stepProps[4].stage<5 ?
                                        <div className={styles.loader}/>
                                    :
                                        <div className={styles.placeresulttext}>{stepProps[4].placeAnalysis && stepProps[4].placeAnalysis.description.replaceAll("**","")}</div>
                                    }
                                </div>
                        </div>
                    }

                    {stepProps[4].stage > 3 &&
                        <div className={styles.reviewframe}>
                                <div className={styles.reviewtitle}>리뷰 분석 결과</div>
                                {stepProps[4].stage<5 ?
                                    <div className={styles.loader}/>
                                :
                                    <>
                                        <div className={styles.indicatorframe}>
                                            {(() => {
                                                if(!stepProps[4].reviewAnalysis)
                                                    return;

                                                const ratios = getReviewTypeRatios(stepProps[4].reviewAnalysis);

                                                return (
                                                    <>
                                                        <div className={styles.indicatortext}>
                                                            {ratios.positive>0 &&
                                                                <div className={styles.positivetext}
                                                                    onClick={() => {
                                                                        setSelectedEvidence({type:'positive', summary:'[긍정 리뷰]', 
                                                                            evidence:stepProps[4].reviewAnalysis.analysis
                                                                            .filter(review=>review.rating>=4)
                                                                            .sort((a, b) => b.rating - a.rating)
                                                                            .map(review  => review.reviewText+` [${review.rating}점]`)});
                                                                        setModalVisible(true);
                                                                    }}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    긍정 {ratios.positive}%
                                                                </div>
                                                            }
                                                            {ratios.neutral>0 &&
                                                                <div className={styles.neutraltext}
                                                                    onClick={() => {
                                                                        setSelectedEvidence({type:'neutral', summary:'[중립 리뷰]', 
                                                                            evidence:stepProps[4].reviewAnalysis.analysis
                                                                            .filter(review=>review.rating==3)
                                                                            .map(review  => review.reviewText+` [${review.rating}점]`)});
                                                                        setModalVisible(true);
                                                                    }}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    중립 {ratios.neutral}%
                                                                </div>
                                                            }
                                                            {ratios.negative>0 &&
                                                                <div className={styles.negativetext}
                                                                    onClick={() => {
                                                                        setSelectedEvidence({type:'negative', summary:'[부정 리뷰]', 
                                                                            evidence:stepProps[4].reviewAnalysis.analysis
                                                                            .filter(review=>review.rating<=2)
                                                                            .sort((a, b) => b.rating - a.rating)
                                                                            .map(review  => review.reviewText+` [${review.rating}점]`)});
                                                                        setModalVisible(true);
                                                                    }}
                                                                    style={{ cursor: 'pointer' }}>
                                                                    부정 {ratios.negative}%
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className={styles.indicatortext}>
                                                            <div className={styles.positiveline} style={{flex:ratios.positive}} />
                                                            <div className={styles.neutraltext1} style={{flex:ratios.neutral}} />
                                                            <div className={styles.negativeline} style={{flex:ratios.negative}} />
                                                            <div className={styles.averageText}>평균 {ratios.average}점</div>
                                                        </div>
                                                    </>
                                                );
                                            })()}
                                        </div>
                                        <div className={styles.positivereviewframe}>
                                            <div className={styles.placetitle}>긍정 리뷰 요약</div>
                                            {stepProps[4].reviewAnalysis && stepProps[4].reviewAnalysis.positive_summary.length>0?
                                                stepProps[4].reviewAnalysis.positive_summary.map((item, index) => (
                                                    <div className={styles.positivereviewsub}
                                                        onClick={() => {
                                                            setSelectedEvidence({type:'positive', summary:`" ${item.summary} "`, evidence:item.evidence});
                                                            setModalVisible(true);
                                                            }}
                                                        style={{ cursor: 'pointer' }}
                                                        key={index}>
                                                        · {item.summary}
                                                    </div>
                                                ))
                                            :
                                                <div className={styles.positivereviewsub}>긍정 리뷰가 없습니다.</div>
                                            }
                                        </div>
                                        <div className={styles.negativereviewframe}>
                                            <div className={styles.placetitle}>부정 리뷰 요약</div>
                                            {stepProps[4].reviewAnalysis && stepProps[4].reviewAnalysis.negative_summary.length>0?
                                                stepProps[4].reviewAnalysis.negative_summary.map((item, index) => (
                                                    <div className={styles.positivereviewsub}
                                                        onClick={() => {
                                                            setSelectedEvidence({type:'negative', summary:`" ${item.summary} "`, evidence:item.evidence});
                                                            setModalVisible(true);
                                                            }}
                                                        style={{ cursor: 'pointer' }}
                                                        key={index}>
                                                        · {item.summary}
                                                    </div>
                                                ))
                                            :
                                                <div className={styles.positivereviewsub}>부정 리뷰가 없습니다.</div>
                                            }
                                        </div>
                                    </>
                                }
                        </div>
                    }
                </div>
                {modalVisible && (
                    <div className={styles.modalOverlay} onClick={() => setModalVisible(false)}>
                        <div className={styles.modalContent} onClick={e => e.stopPropagation()}>
                            <div className={selectedEvidence.type == 'positive'? styles.positivetext : (selectedEvidence.type == 'negative' ? styles.negativetext : styles.neutraltext)}>{selectedEvidence.summary}</div>
                            {selectedEvidence.evidence.map((text, i) => (
                                <p key={i} className={styles.modalEvidence}>· {text}</p>
                            ))}
                        </div>
                    </div>
                    )}
            </div>
            <div className={styles.nextbuttonframe}>
      			<div className={styles.backbutton2} onClick={()=>setAdViseStep(3)}>
        				<div className={styles.nextbuttontext2}>다른 핫플 선택</div>
      			</div>
      			<div className={stepProps[4].stage==5 ? styles.nextbutton : styles.nextbuttonDisabled} onClick={whenNextButtonClicked}>
        				<b className={styles.nextbuttontext1}>계속할래요 →</b>
      			</div>
    		</div>
        </div>
    );
}

export default AdViseStep4;